import React from 'react'
import { Col } from 'react-bootstrap'
import LabelCustomSmall from '../../../../label-custom-small'
import { Controller } from 'react-hook-form'
import Autocomplete from '../../../../custom/autocomplete'
import UseIncomeLangFeeType from '../../../../../hooks/use-income-lang-fee'
import UseIncomeEXPFeeType from '../../../../../hooks/use-income-exp-fee'
import UseIncomeOTFlatrateType from '../../../../../hooks/use-income-ot-flatrate'
import UseIncomeShiftFlatrateType from '../../../../../hooks/use-income-shift-flatrate'

export default function IncomeCard({
  isRead,
  dataDetail,
  travels,
  control,
  errors,
  phone
}) {
  const langFeeType = UseIncomeLangFeeType()
  const OTFlatrateType = UseIncomeOTFlatrateType()

  const expFeeType = UseIncomeEXPFeeType()
  const shiftFlatrate = UseIncomeShiftFlatrateType()

  return (
    <>
      {' '}
      <ColFrom>
        <LabelCustomSmall className={`${!isRead ? 'fw-light' : 'fw-bold'}`}>
          การเดินทาง
        </LabelCustomSmall>
        {!isRead ? (
          <Controller
            name={'travel'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Autocomplete
                disabled={isRead}
                isClearable={false}
                options={travels}
                value={value}
                onChange={onChange}
              />
            )}
          />
        ) : (
          <div className="fw-light small">{dataDetail?.travelling ?? '-'}</div>
        )}
        {errors.travel?.message && (
          <label className="small text-danger">{errors.travel.message}</label>
        )}
      </ColFrom>
      <ColFrom>
        <LabelCustomSmall className={`${!isRead ? 'fw-light' : 'fw-bold'}`}>
          ค่าโทรศัพท์
        </LabelCustomSmall>
        {!isRead ? (
          <Controller
            name={'phone'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Autocomplete
                disabled={isRead}
                isClearable={false}
                options={phone}
                value={value}
                onChange={onChange}
              />
            )}
          />
        ) : (
          <div className="fw-light small">
            {dataDetail?.phone_packet ?? '-'}
          </div>
        )}
      </ColFrom>
      <ColFrom className="">
        <LabelCustomSmall className={`${!isRead ? 'fw-light' : 'fw-bold'}`}>
          OT เหมาจ่าย
        </LabelCustomSmall>
        {!isRead ? (
          <Controller
            name={'otFlatRate'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Autocomplete
                disabled={isRead}
                // disabled={true}
                options={OTFlatrateType}
                value={value}
                onChange={onChange}
              />
            )}
          />
        ) : (
          <div className="fw-light small">
            {dataDetail?.ot_flat_rate ?? '-'}
          </div>
        )}
      </ColFrom>
      <ColFrom>
        <LabelCustomSmall className={`${!isRead ? 'fw-light' : 'fw-bold'}`}>
          OT วันทำงานปกติ
        </LabelCustomSmall>
        {!isRead ? (
          <>
            <Controller
              name={'otShift'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Autocomplete
                  options={[
                    {
                      label: 'ไม่มี',
                      value: 0
                    },
                    {
                      label: 'มี',
                      value: 1
                    }
                  ]}
                  value={value}
                  onChange={onChange}
                  defaultValue={
                    dataDetail?.ot_shift
                      ? dataDetail?.ot_shift === 1
                        ? 1
                        : 0
                      : 0
                  }
                />
              )}
            />
          </>
        ) : (
          <div className="fw-light small">
            {dataDetail?.ot_shift === 1 ? 'มี' : 'ไม่มี'}
          </div>
        )}
      </ColFrom>
      <ColFrom>
        <LabelCustomSmall className={`${!isRead ? 'fw-light' : 'fw-bold'}`}>
          ค่าภาษา
        </LabelCustomSmall>
        {!isRead ? (
          <Controller
            name={'languageFee'}
            control={control}
            render={({ field: { onChange, value = null } }) => (
              <Autocomplete
                // disabled={isRead}
                options={langFeeType}
                value={value}
                onChange={onChange}
              />
            )}
          />
        ) : (
          <div className="fw-light small">{dataDetail?.lang_fee ?? '-'}</div>
        )}
      </ColFrom>
      <ColFrom>
        <LabelCustomSmall className={`${!isRead ? 'fw-light' : 'fw-bold'}`}>
          ค่าประสบการณ์
        </LabelCustomSmall>
        {!isRead ? (
          <Controller
            name={'experienceFee'}
            control={control}
            render={({ field: { onChange, value = null } }) => (
              <Autocomplete
                options={expFeeType}
                value={value}
                onChange={onChange}
              />
            )}
          />
        ) : (
          <div className="fw-light small">{dataDetail?.exp_fee ?? '-'}</div>
        )}
      </ColFrom>
      <ColFrom>
        <LabelCustomSmall className={`${!isRead ? 'fw-light' : 'fw-bold'}`}>
          ค่ากะเหมาจ่าย
        </LabelCustomSmall>
        {!isRead ? (
          <Controller
            name={'shiftFlatRate'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Autocomplete
                disabled={isRead}
                // disabled={true}
                options={shiftFlatrate}
                value={value}
                onChange={onChange}
              />
            )}
          />
        ) : (
          <div className="fw-light small">
            {dataDetail?.shift_flat_rate ?? '-'}
          </div>
        )}
      </ColFrom>
    </>
  )
}

const ColFrom = (props) => {
  const { children, className = '', ...other } = props

  return (
    <Col xl={3} xs={6} md={4} className={` ${className}`} {...other}>
      {children}
    </Col>
  )
}
